import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FranchiseFaqs from "./component";

const mapStateToProps = ({
    franchise: { faqList }
}) => ({
    faqList
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FranchiseFaqs);

